<template>
  <v-dialog v-model="show"
            :fullscreen="isDesktop"
            :content-class="`modal ${isDesktop ? '' : 'interaction'}`"
            :width="width">

    <v-card class="preview-interaction-wrapper"
            :class="{'preview-interaction-wrapper_desktop': isDesktop}"
            :key="dataAdvertisingId"
            v-if="interaction">

      <app-interaction class="preview-interaction-wrapper-item"
                       preview
                       :loading="loading"
                       :isPreviewOpen="show"
                       :data-interaction="interaction"
                       :isCampaignsListPreview="isCampaignsListPreview"
                       :is-desktop="isDesktop"
                       @next="next" />

    </v-card>

  </v-dialog>
</template>

<script>
import AppInteraction from "./InteractionsPreview";
import _ from "lodash";

export default {
  components: {
    AppInteraction,
  },

  data() {
    return {
      show: false,
      interaction: null,
      loading: false,
      width: "337",
    };
  },

  props: {
    dataAdvertisingId: {
      type: Number,
      required: true,
    },
    isDesktop: {
      required: false,
      default: false,
    },
    isCampaignsListPreview: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    interaction(val) {
      if (val && val.tipo === "VIDEO") this.width = "315";
    },
    show(val) {
      if (!val) {
        this.interaction = null;
      }
    },
  },

  methods: {
    async start() {
      this.loading = true;
      this.show = true;

      const interaction = await this.$api.interactions.preview.start({
        advertisingId: this.dataAdvertisingId,
      });

      this.interaction = this.parseStyles(interaction);
      this.loading = false;
    },

    async next(optionId) {
      this.loading = true;

      const interaction = await this.$api.interactions.preview.next({
        advertisingId: this.dataAdvertisingId,
        interactionId: this.interaction.id,
        optionId,
      });

      if (interaction.liberacao === "preview") return (this.show = false);

      this.interaction = this.parseStyles(interaction);

      this.loading = false;
    },

    parseStyles(interaction) {
      if (interaction.estilo)
        interaction.estilo = JSON.parse(interaction.estilo);

      _.forEach(interaction.opcoes, (option, index) => {
        if (interaction.opcoes[index].estilo)
          interaction.opcoes[index].estilo = JSON.parse(
            interaction.opcoes[index].estilo
          );
      });

      return interaction;
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-interaction-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;

  .preview-interaction-wrapper-item {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  &.preview-interaction-wrapper_desktop {
    .preview-interaction-wrapper-item {
      height: 100%;
      background: transparent;
    }
  }
}
</style>
